export default "__VITE_ASSET__CgA_zIyj__"